import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./component/navbar";
import Footer from "./home components/Footer";

function Layout() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith("/admin");
  const isUserDashboardRoute = [
    "/dashboard",
    "/order-section",
    "/profile",
    "/Receipt",
    "/ViewDetails",
  ].some((route) => location.pathname.startsWith(route));
  const usePublicBackground = !isAdminRoute && !isUserDashboardRoute;

  return (
    <div className={usePublicBackground ? "user-public-shell" : undefined}>
      <Navbar />
      <Outlet />
      {!isAdminRoute && <Footer />}
    </div>
  );
}

export default Layout;
